import { useState } from "react";
import { Dialog } from "@themes/pollinator/ui/Dialog";
import VideoMeetingRoleAndDescriptionContainer from "../../components/VideoMeetingRoleAndDescription/VideoMeetingRoleAndDescriptionContainer";
import type { MeetingDetails } from "@core/features/videoMeeting";
import Type from "@themes/pollinator/ui/Type";

type Props = {
  meetingDetails: MeetingDetails;
  onClose?: () => void;
};

export function VideoMeetingIntroDialog({ meetingDetails, onClose }: Props) {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    onClose?.();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={handleClose}
      isFixed={false}
      title={`Welcome to ${meetingDetails.title}`}
      description="We’re so glad you’re here. Take a moment to get settled before connecting with everyone."
      primaryButtonText="Got it"
      onPrimaryClick={handleClose}
      containerClassName="h-fit max-h-full max-w-md min-h-auto rounded-lg"
      backdropClassName="justify-center items-center"
    >
      <div className="flex flex-col items-center justify-center h-full gap-4">
        <div className="flex flex-col gap-8 border border-brand-800 rounded-md p-4 shadow-md bg-brand-100 w-full">
          <VideoMeetingRoleAndDescriptionContainer
            meetingDetails={meetingDetails}
          />
        </div>
        <Type variant="body2">
          All the materials you need, including the script for today, are in the{" "}
          <span className="font-bold">materials tab</span> (alongside the Chat
          and Participants tabs).
        </Type>
      </div>
    </Dialog>
  );
}
